import { CommonFeatureFlags } from "@lyteflo/types";

export const FeatureFlags = {
  EV_INFO_CARDS_V2_PORTAL: CommonFeatureFlags.EV_INFO_CARDS_V2_PORTAL,
  TESLA_OTA: CommonFeatureFlags.TESLA_OTA,
  CAMPAIGN_EMAIL_CHANNEL: "campaign_email_channel",
} as const;

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags];

/** Flags that `?lf_flag_{key}=show|hide` may override for the session. */
export const URL_OVERRIDABLE_FEATURE_FLAGS: string[] = [FeatureFlags.TESLA_OTA];
